function headerHav() {
  init();
}
function init() {
  var holderForClass = jQuery('body');
  var headerBtn = jQuery('.hamburger');
  var activeCls = 'nav-active';
  headerBtn.on('click', function () {
    !holderForClass.hasClass(activeCls) ? animateHeaderNavLinks(true) : animateHeaderNavLinks(false);
    holderForClass.toggleClass(activeCls);
  });
}
function animateHeaderNavLinks(isOpen) {
  var navLink = jQuery('.header-nav a');
  if (!isOpen) {
    jQuery(navLink).removeAttr('style');
    return;
  }
  var _loop = function _loop() {
    var item = navLink[i];
    setTimeout(function () {
      jQuery(item).css('opacity', 1);
      jQuery(item).css('transform', 'translate(0, 0)');
    }, i * 130);
  };
  for (var i = navLink.length - 1; i >= 0; i--) {
    _loop();
  }
}
export default headerHav;